export {
  getSignupAttendanceMarking,
  compareMarking,
}

function getSignupAttendanceMarking( signup ) {
  if( !signup ) return '_'
  if( signup.absent ) return '_'

  // Attending
  if( signup.state == 'Attending' ) {

    if( signup.subbedin ) return 'I'       // Subbed In

    return 'A'                             // Attending
  }

  // 'Unplanned'  (but they could be on bench, so taking priority here)
  if( signup.noshow ) return 'N'           // No show
  if( signup.droppedout ) return 'O'       // Dropped Out

  // Bench
  if( signup.state == 'Bench' ) {
  
    if( signup.bench ) {  
      if( signup.benchcheckin ) return 'Y' // Requested bench and checked in
      return 'R'                           // Requested bench
    }

    if( signup.benchcheckin ) return 'C'   // Checked in

    return 'B'                             // Bench
  }
  
  return '_'
}

function getMarkingRanking( marking ) {
  // This is to sort an array of signups
  // in which player, class/spec, and raidevent are the same
  switch(marking ) {
    case 'A': return 1;
    case 'I': return 2;
    case 'Y': return 3;
    case 'C': return 4;
    case 'B': return 5;
    case 'R': return 6;
    case 'N': return 7;
    case 'O': return 8;

    default: return 99;
  }
}

function compareMarking( a, b ) {
  const rankinga = getMarkingRanking( a )
  const rankingb = getMarkingRanking( b )
  if ( rankinga < rankingb ) {
    return -1
  }
  if ( rankinga > rankingb ) {
    return 1
  }
  return 0
}
